export default {"src":"/_next/static/media/bikeAlert_64.d089ce50.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};